export default {"src":"/_next/static/media/light.d454dc56.svg","height":96,"width":549,"blurWidth":0,"blurHeight":0};